/**
 * Tab Logic.
 *
 * @package Embark
 * @since   1.0.0
 */

export const initTabs = (editorBlock = false) => {
	const blocks = document.querySelectorAll('.em-tabs');

	blocks.forEach((block) => {
		const tabLogic = () => {
			let tabs = block.querySelectorAll('.em-tab');
			const nav = block.querySelector('.em-tabs__nav');
			let navItems = nav.querySelectorAll('.em-tabs__nav-item');
			const isDesktop = window.matchMedia('(min-width: 851px)').matches;

			const createNavItem = (tab, i, className) => {
				const html = document.createElement('div');
				const tabInner = tab.querySelector('.em-tab__container');
				const selected = i === 0;
				const label = tabInner?.dataset?.label ?? 'Add Label';
				html.innerHTML = `<button id="${tab.id}_${i}" role="tab" aria-selected="${selected}" aria-controls="${tab.id}" class="${className}" tabindex="0">${label}</div>`;
				tab.setAttribute('aria-labelledby', `${tab.id}_${i}`);
				tab.setAttribute('role', 'tabpanel');
				return html.firstChild;
			};

			if (isDesktop && !nav.firstElementChild) {
				if (tabs.length !== navItems.length) {
					nav.innerHTML = '';
					tabs.forEach((tab, i) => {
						nav.append(createNavItem(tab, i, 'em-tabs__nav-item'));
					});
					navItems = nav.querySelectorAll('.em-tabs__nav-item');
				} else {
					tabs.forEach((tab, i) => {
						const tabInner = tab.querySelector('.em-tab__container');
						if (tabInner?.dataset?.label) {
							navItems[i].innerText = tabInner.dataset.label;
						}
					});
				}
			}

			if (!isDesktop && !tabs[0].firstElementChild.classList.contains('em-tab__label')) {
				nav.innerHTML = '';
				tabs.forEach((tab, i) => {
					tab.prepend(createNavItem(tab, i, 'em-tab__label'));
				});
				navItems = block.querySelectorAll('.em-tab__label');
			}

			if (editorBlock) {
				tabs = block.querySelectorAll('[data-type="acf/tab"]');
			}

			navItems.forEach((item, navIndex) => {
				const accordionClose = () => {
					item.classList.remove('active');
					item.classList.add('inactive');
					item.setAttribute('aria-selected', 'false');
					tabs[navIndex].setAttribute('data-active', 'false');
					tabs[navIndex].setAttribute('aria-selected', 'false');
				};

				const tabState = () => {
					tabs.forEach((tab) => {
						tab.setAttribute('data-active', 'false');
						tab.setAttribute('aria-selected', 'false');
					});

					navItems.forEach((item) => {
						item.classList.remove('active');
						item.classList.add('inactive');
						item.setAttribute('aria-selected', 'false');
					});
					item.classList.add('active');
					item.classList.remove('inactive');
					item.setAttribute('aria-selected', 'true');

					tabs[navIndex].setAttribute('data-active', 'true');
					tabs[navIndex].setAttribute('aria-selected', 'true');

					if (editorBlock[0]) {
						tabs[navIndex].focus();
					}
				};

				const toggleTab = () => {
					if (!isDesktop && item.classList.contains('active')) {
						accordionClose();
					} else {
						tabState();
					}
				};

				item.onclick = () => {
					toggleTab();
				};

				item.onkeydown = function (e) {
					if (e.key === 'Enter') {
						toggleTab();
					}
				};
			});
		};

		tabLogic();

		window.addEventListener('resize', () => {
			if (window.matchMedia('(min-width: 851px)').matches || window.matchMedia('(max-width: 850px)').matches) {
				tabLogic();
			}
		});

		if (editorBlock) {
			// identify an element to observe
			const elementToObserve = block.querySelector('.em-tabs__tabs');

			// create a new instance of `MutationObserver` named `observer`,
			// passing it a callback function
			const observer = new MutationObserver(() => {
				tabLogic();
			});

			// call `observe()` on that MutationObserver instance,
			// passing it the element to observe, and the options object
			observer.observe(elementToObserve, { subtree: true, childList: true });
		}
	});
};

initTabs();
